// extracted by mini-css-extract-plugin
export default {"header":"SubscriptionsModal_header__Wp53L","tabMenu":"SubscriptionsModal_tabMenu__YadjO"};